import React from 'react';
import PropTypes from 'prop-types';
import DefaultBody from './DefaultBody';
import config from '@plone/volto/registry';

const TeaserView = (props) => {
  const { data } = props;
  const hasType = data.href?.[0]?.['@type'];

  // Stile per il contenitore full-width
  const containerStyle = {
    backgroundColor: data.background_color || 'transparent',
    width: '100vw',
    position: 'relative',
    left: '49%',
    right: '50%',
    marginLeft: '-50vw',
    marginRight: '-50vw',
    padding: '2rem 0' // Spaziatura interna
  };

  // Stile per il contenuto centrato
  const contentStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1rem'
  };

  const BodyComponent =
    (config?.getComponent &&
      hasType &&
      config.getComponent({ name: 'Teaser', dependencies: [hasType] })
        .component) ||
    DefaultBody;

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <BodyComponent {...props} />
      </div>
    </div>
  );
};

TeaserView.propTypes = {
  data: PropTypes.shape({
    background_color: PropTypes.string,
    href: PropTypes.array,
  }),
};

TeaserView.defaultProps = {
  data: {},
};

export default TeaserView;